import { get, onValue, ref } from 'firebase/database';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { db } from '../Database';
import { useUserContext } from '../contexts/user';
import { usePopUpContext } from '../contexts/Popup';
import { useLoaderContext } from '../contexts/loader';

const ChallengeResult = () => {
    const navigate = useNavigate();

    const { id } = useParams();

    const [challengeData, setChallengeData] = useState({});
    const [remainingTime, setRemainingTime] = useState({ minutes: 0, seconds: 0, });
    const [correctAndWrongAnswers, setCorrectAndWrongAnswers] = useState({ correct: 0, wrong: 0, });
    const [userData, setUserData] = useState({});
    const [dataRendered, setDataRendered] = useState(false);

    const { userInfo, appLanguage } = useUserContext();
    const { setMessageContent } = usePopUpContext();
    const { setIsLoading } = useLoaderContext();

    useEffect(() => {
        if (userInfo.id) {
            setIsLoading(prev => prev + 1);
            get(ref(db, "challenges/" + id)).then(snapShot => {
                const challenge = snapShot.val();
                setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
                if (challenge) {
                    const user = challenge.users?.find(user => user.user_id === userInfo.id);
                    if (user || challenge.creator_id === userInfo.id) {
                        if (!user.finished) {
                            if (challenge.status === "solving") {
                                navigate("/solving-challenge/" + id);
                            } else {
                                navigate("/challenge/" + id);
                            }
                        } else {
                            setUserData(user);
                            setChallengeData(challenge);
                            setDataRendered(true);
                            let remainingDifference = challenge.challengeEndsAt - new Date().getTime();
                            let interval = setInterval(() => {
                                remainingDifference = challenge.challengeEndsAt - new Date().getTime();
                                if (remainingDifference > 0) {
                                    setRemainingTime({
                                        minutes: Math.floor(remainingDifference / 1000 / 60),
                                        seconds: Math.floor(remainingDifference / 1000 % 60),
                                    })
                                } else {
                                    clearInterval(interval);
                                }
                            }, 1000)

                            const answers = [...user.answers];
                            let correct_answers = 0;
                            let wrong_answers = 0;
                            for (let i = 0; i < answers.length; i++) {
                                if (answers[i] === challenge.questions[i].correct_answer) {
                                    correct_answers += 1;
                                } else {
                                    wrong_answers += 1;
                                }
                            }
                            setCorrectAndWrongAnswers({
                                correct: correct_answers,
                                wrong: wrong_answers,
                            })
                        }
                    } else {
                        setMessageContent({
                            title: appLanguage === "ar" ? "التحدي غير موجود" : "Challenge Not Found",
                            message: appLanguage === "ar" ? "هذا التحدي غير موجود في قاعدة البيانات لدينا." : "The challenge is not found in our database.",
                        })
                        navigate("/live-challenge/join");
                    }
                } else {
                    setMessageContent({
                        title: appLanguage === "ar" ? "التحدي غير موجود" : "Challenge Not Found",
                        message: appLanguage === "ar" ? "هذا التحدي غير موجود في قاعدة البيانات لدينا." : "The challenge is not found in our database.",
                    })
                    navigate("/live-challenge/join");
                }
            }).catch(() => {
                setMessageContent({
                    title: appLanguage === "ar" ? "خطأ أثناء الجلب" : "Fetching Error",
                    message: appLanguage === "ar" ? "حدث خطأ أثناء جلب بيانات التحدي." : "Oops! something went wrong while fetching challenge data.",
                })
                navigate("/live-challenge/join");
            })
        }
    }, [userInfo])

    const selectPercentageColor = (percentage) => {
        if (percentage >= 80) return "#0b0"
        else if (percentage >= 50) return "#f90"
        else return "#f00";
    }

    useEffect(() => {
        if (challengeData.challenge_code) {
            onValue(ref(db, "challenges/" + id + "/users"), (snapShot) => {
                const users = snapShot.val()?.sort((a, b) => (b.points || 0) - (a.points || 0));
                setChallengeData(prev => ({
                    ...prev,
                    users
                }))
            })

            const statusChanged = (snapShot) => {
                if (snapShot.val() === "waiting") {
                    navigate("/challenge/" + id);
                }
            }

            onValue(ref(db, "challenges/" + id + "/status"), statusChanged)
        }
    }, [dataRendered])

    return (
        <div className="challenge_result_container">
            <header>
                <p className="title">{appLanguage === "ar" ? "نتيجة التحدي" : "Challenge Result"}</p>
                <p className="remaining_time">{remainingTime.minutes < 10 ? "0" + remainingTime.minutes : remainingTime.minutes}:{remainingTime.seconds < 10 ? "0" + remainingTime.seconds : remainingTime.seconds}</p>
            </header>
            <div className="details_container">
                <p className="title">{appLanguage === "ar" ? "تفاصيل النتيجة" : "Result Details"}</p>
                <div className="content">
                    <div className="points">
                        <p className="key">{appLanguage === "ar" ? "النقاط :" : "Points :"} </p>
                        <p className="value">{userData?.points}</p>
                    </div>
                    <div className="correct_answers">
                        <p className="key">{appLanguage === "ar" ? "الإجابات الصحيحة :" : "Correct Answers :"} </p>
                        <p className="value">{correctAndWrongAnswers.correct}</p>
                    </div>
                    <div className="wrong_answers">
                        <p className="key">{appLanguage === "ar" ? "الإجابات الخاطئة :" : "Wrong Answers :"} </p>
                        <p className="value">{correctAndWrongAnswers.wrong}</p>
                    </div>
                </div>
            </div>
            <div className="ranking_container">
                <p className="title">{appLanguage === "ar" ? "الترتيب" : "Ranking"}</p>
                <div className="content">
                    {
                        challengeData.users ?
                            challengeData.users.filter(user => user.finished)?.sort((a, b) => (b.points || 0) - (a.points || 0)).map((user, i) => {
                                return <div className="student" key={"student_" + i}>
                                    <div className="left_side">
                                        <p className="rank">#{i + 1}</p>
                                        <p className="username">{user.username}</p>
                                    </div>
                                    <div className="right_side">
                                        <p className="percentage" style={{ color: selectPercentageColor(Math.round(user.points / (challengeData.questions.length * 5) * 100)), }}>{Math.round(user.points / (challengeData.questions.length * 5) * 100)}%</p>
                                    </div>
                                </div>
                            })
                            : <p>{appLanguage === "ar" ? "جاري جلب البيانات..." : "Fetching Data..."}</p>
                    }
                </div>
            </div>
            <div className="questions">
                <p className="title">{appLanguage === "ar" ? "الأسئلة" : "Questions"}</p>
                <div className="content">
                    {
                        challengeData.questions ?
                            challengeData.questions.map((question, i) => {
                                return <div className="question" key={"question_" + i}>
                                    {!userData.answers || !userData.answers[i] || userData.answers[i].empty ? <span>{appLanguage === "ar" ? "لا توجد إجابة" : "No Answer"}</span> : undefined}
                                    <p className="question_text">{question.text}</p>
                                    <div className="answers">
                                        <button className={(question.correct_answer === question?.answers[0] ? "correct_answer " : "") + ((userData.answers ? userData.answers[i] : undefined) === question?.answers[0] ? "choosed_answer" : "")}>{question.answers[0]}</button>
                                        <button className={(question.correct_answer === question?.answers[1] ? "correct_answer " : "") + ((userData.answers ? userData.answers[i] : undefined) === question?.answers[1] ? "choosed_answer" : "")}>{question.answers[1]}</button>
                                        <button className={(question.correct_answer === question?.answers[2] ? "correct_answer " : "") + ((userData.answers ? userData.answers[i] : undefined) === question?.answers[2] ? "choosed_answer" : "")}>{question.answers[2]}</button>
                                        <button className={(question.correct_answer === question?.answers[3] ? "correct_answer " : "") + ((userData.answers ? userData.answers[i] : undefined) === question?.answers[3] ? "choosed_answer" : "")}>{question.answers[3]}</button>
                                    </div>
                                </div>
                            })
                            : <p>{appLanguage === "ar" ? "لا توجد أسئلة" : "No Questions"}</p>
                    }
                </div>
            </div>
        </div>
    )
}

export default ChallengeResult;